<template>
  <div class="pages">
    <div class="box" :style="{ height: height + 'px' }">
      <div class="left"></div>
      <div class="right">
        <p class="title">Account registration</p>
        <li class="li">
          <input v-model="mailbox" placeholder="Please enter email address" />
        </li>
        <li class="li3">
          <div class="li3_left">
            <select @change="selectcity($event)">
              <option v-for="(item, index) in prefixList" :key="index">
                {{ item.name }}
              </option>
            </select>
          </div>
          <input type="text" v-model="phone"
            @input="phone = phone.replace(/[^\d]/g, '')" maxlength="11"
            class="li3_right"
            placeholder="Please enter your mobile phone number" />
        </li>
        <div
          style="display:flex;justify-content: space-between;width: 100%;align-items: center;">
          <p class="btn" style="width:200px;"><span @click="getyzmNew"
              style="font-size: 12px;">{{ interval==undefined?'Get phone verification code':times+'s' }}
            </span></p>
          <p style="color:#ffffff">or</p>
          <p class="btn" style="width:200px"><span style="font-size: 12px;"
              @click="getyzmNew('email')">{{ intervalEmail==undefined?'Get email verification code':times+'s' }}
            </span></p>
        </div>
        <li class="li">
          <input v-model="code" maxlength="6"
            @input="code = code.replace(/[^\d]/g, '')"
            placeholder="Please enter the verification code" />
          <!-- <span v-if="interval==undefined" @click="getyzm">Get verification
            code</span>
          <span v-else>{{ times }}s </span> -->
        </li>

        <li class="li">
          <input v-model="name" placeholder="Please enter your name" />
        </li>
        <li class="li">
          <input v-model="companyName"
            placeholder="Please enter company name" />
        </li>
        <li class="li">
          <input v-model="companyWeb"
            placeholder="Company website (optional)" />
        </li>
        <li class="li">
          <input v-model="companyAddress"
            placeholder="Please enter company address" />
        </li>
        <li class="li2">
          <el-upload class="avatar-uploader" :action="imageUrl"
            :show-file-list="false" :on-success="getUpload1">
            <img v-if="imageUrl1" :src="imageUrl1" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <span>Please upload the company's business license</span>
        </li>
        <li class="li2">
          <el-upload class="avatar-uploader" style="width: 90px;"
            :action="imageUrl" :show-file-list="false" :on-success="getUpload2">
            <img v-if="imageUrl2" :src="imageUrl2" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <span>Please upload the company logo</span>
        </li>

        <li class="li">
          <input type="password" v-model="password"
            placeholder="Please input a password" />
        </li>
        <li class="li">
          <input type="password" v-model="dbpassword"
            placeholder="Please enter the password again" />
        </li>
        <p class="xieyi">
          <input type="radio" v-model="check" :value="true" name="check"
            class="radioBox" @change="checkChange">
          <span @click="checkChange">By registering, you agree to our</span>
          <router-link :to="{ path: '/agreement', query: { type: 2 } }">
            service agreement
          </router-link>
          and
          <router-link :to="{ path: '/agreement', query: { type: 1 } }">
            privacy policy
          </router-link>
        </p>
        <p class="btn"><span @click="subimt">register</span></p>
        <p class="btn"><span @click="login">Sign in</span></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'register',
  data () {
    return {
      height: '',
      mailbox: '', //邮箱
      name: '', //名字
      companyName: '', //公司名称
      companyWeb: '', //公司网址
      companyAddress: '', //公司地址
      imageUrl1: '', //公司营业执照
      imageUrl2: '', //公司logo
      country: '', //国家
      phone: '', //手机号
      code: '', //验证码
      password: '', //密码
      dbpassword: '', //确定密码
      times: 60,
      prefixList: [], //前缀数组
      prefix: '', //前缀手机号
      check: false,
      interval: undefined,//获取验证码计时器
      intervalEmail: undefined,//获取验证码计时器
    };
  },
  created () {
    this.height = window.innerHeight;
    this.getPrefix();
  },
  methods: {
    checkChange (e) {
      this.check = true
    },
    // 上传营业执照
    getUpload1 (res, file) {
      this.imageUrl1 = res.url;
    },
    // 上传公司logo
    getUpload2 (res, file) {
      this.imageUrl2 = res.url;
    },
    // 获取手机号前缀
    getPrefix () {
      this.$api.prefix({}).then(res => {
        console.log(res);
        if (res.result == 0) {
          this.prefixList = res.dataList;
          this.prefix = res.dataList[0].name;
        }
      });
    },
    // 手机号前缀
    selectcity (e) {
      this.prefix = e.target.value;
    },
    // 获取验证码
    getyzmNew (type) {

      if (type == 'email') {
        if (this.intervalEmail) {
          return
        }
        if (!this.mailbox) {
          this.$message({
            message: 'Please enter your  email address!',
            type: 'error',
            center: true,
            duration: 1000
          });
          return
        }
        var isEmail = /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/;
        if (isEmail.test(this.mailbox)) {
          this.$api.getCodeMail({
            mail: this.mailbox
          }).then(res => {
            if (res.result == 0) {
              this.$message({
                message: "The verification code has been sent to your email",
                type: 'success',
                center: true,
                duration: 1000
              });
              this.getcodeEmail();
            } else {
              this.$message({
                message: res.resultNote,
                type: 'error',
                center: true,
                duration: 1000
              });
            }
          });
          return;
        } else {
          this.$message({
            message: 'Please enter your  email address!',
            type: 'error',
            center: true,
            duration: 1000
          });
          return
        }
      } else {
        if (this.interval) {
          return
        }
        if (!this.phone) {
          this.$message({
            message: 'Please enter your mobile phone!',
            type: 'error',
            center: true,
            duration: 1000
          });
          return
        }
        var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (myreg.test(this.phone)) {
          let data = {
            prefix: this.prefix,
            phone: this.phone
          };
          this.$api.code(data).then(res => {
            if (res.result == 0) {
              this.$message({
                message: "Verification code has been sent to your mobile phone",
                type: 'success',
                center: true,
                duration: 1000
              });
              this.getcode();
            } else {
              this.$message({
                message: res.resultNote,
                type: 'error',
                center: true,
                duration: 1000
              });
            }
          });
          return;
        } else {
          this.$message({
            message: 'The phone number is incorrect!',
            type: 'error',
            center: true,
            duration: 1000
          });
        }
      }




    },
    getyzm () {
      if (!this.phone && !this.mailbox) {
        this.$message({
          message: 'Please enter your phone number or email address!',
          type: 'error',
          center: true,
          duration: 1000
        });
        return
      }
      var isEmail = /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/;
      if (isEmail.test(this.mailbox)) {
        this.$api.getCodeMail({
          mail: this.mailbox
        }).then(res => {
          if (res.result == 0) {
            this.$message({
              message: "The verification code has been sent to your email",
              type: 'success',
              center: true,
              duration: 1000
            });
            this.getcodeEmail();
          } else {
            this.$message({
              message: res.resultNote,
              type: 'error',
              center: true,
              duration: 1000
            });
          }
        });
        return;
      }
      var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (myreg.test(this.phone)) {
        let data = {
          prefix: this.prefix,
          phone: this.phone
        };
        this.$api.code(data).then(res => {
          if (res.result == 0) {
            this.$message({
              message: "Verification code has been sent to your mobile phone",
              type: 'success',
              center: true,
              duration: 1000
            });
            this.getcode();
          } else {
            this.$message({
              message: res.resultNote,
              type: 'error',
              center: true,
              duration: 1000
            });
          }
        });
        return;
      }
      this.$message({
        message: 'The phone number or email format is incorrect!',
        type: 'error',
        center: true,
        duration: 1000
      });
    },
    // 获取验证码倒计时
    getcode () {
      if (this.interval) {
        return
      }
      this.times = 60;
      this.interval = setInterval(() => {
        --this.times;
        if (this.times <= 0) {
          clearInterval(this.interval);
          this.interval = undefined
        }
      }, 1000);
    },
    getcodeEmail () {
      if (this.intervalEmail) {
        return
      }
      this.times = 60;
      this.intervalEmail = setInterval(() => {
        --this.times;
        if (this.times <= 0) {
          clearInterval(this.intervalEmail);
          this.intervalEmail = undefined
        }
      }, 1000);
    },
    // 注册
    subimt () {
      if (!this.phone) {
        this.$message({
          message: 'Please fill in your mobile phone number',
          type: 'error',
          center: true,
          duration: 1000
        });
        return;
      }
      var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!myreg.test(this.phone)) {
        this.$message({
          message: 'The format of your mobile phone number is incorrect',
          type: 'error',
          center: true,
          duration: 1000
        });
        return;
      }
      if (!this.check) {
        this.$message({
          message: 'Please agree to our service Agreement and privacy policy',
          type: 'error',
          center: true,
          duration: 1000
        });
        return;
      }
      if (this.mailbox == '') {
        this.$message({
          message: 'Please fill in the email',
          type: 'error',
          center: true,
          duration: 1000
        });
        return;
      }
      if (this.name == '') {
        this.$message({
          message: 'Please fill in your name',
          type: 'error',
          center: true,
          duration: 1000
        });
        return;
      }
      if (this.companyName == '') {
        this.$message({
          message: 'Please fill in the company name',
          type: 'error',
          center: true,
          duration: 1000
        });
        return;
      }
      if (this.companyAddress == '') {
        this.$message({
          message: 'Please fill in the company address',
          type: 'error',
          center: true,
          duration: 1000
        });
        return;
      }
      if (this.imageUrl1 == '') {
        this.$message({
          message: 'Please upload the companys business license',
          type: 'error',
          center: true,
          duration: 1000
        });
        return;
      }
      if (this.imageUrl2 == '') {
        this.$message({
          message: 'Please upload company Logo',
          type: 'error',
          center: true,
          duration: 1000
        });
        return;
      }
      if (this.code == '') {
        this.$message({
          message: 'Please enter the verification code',
          type: 'error',
          center: true,
          duration: 1000
        });
        return;
      }
      if (this.password.length < 6) {
        this.$message({
          message: 'The password must be at least six digits',
          type: 'error',
          center: true,
          duration: 1000
        });
        return;
      }
      if (this.password !== this.dbpassword) {
        this.$message({
          message: 'Inconsistent password input',
          type: 'error',
          center: true,
          duration: 1000
        });
        return;
      }
      let data = {
        mail: this.mailbox,
        name: this.name,
        company: this.companyName,
        webSite: this.companyWeb,
        address: this.companyAddress,
        businessLicense: this.imageUrl1,
        logo: this.imageUrl2,
        prefix: this.prefix,
        phone: this.phone,
        code: this.code,
        password: this.$md5(this.dbpassword)
      };
      this.$api.register(data).then(res => {
        console.log(res);
        if (res.result == 0) {
          let that = this;
          that.$message({
            message: 'login was successful',
            type: 'success',
            center: true,
            duration: 1000,
            onClose: function () {
              that.$router.push({ path: '/' });
            }
          });
        } else {
          this.$message({
            message: res.resultNote,
            type: 'error',
            center: true,
            duration: 1000
          });
        }
      });
    },
    // 登录
    login () {
      this.$router.push({ path: '/' });
    }
  }
};
</script>

<style lang="scss" scoped>
.pages {
  background: #000;
  box-sizing: border-box;
  .box {
    display: flex;
    align-items: flex-start;
    .left {
      width: 60%;
      height: 100%;
      background-image: url(../../assets/bg.png);
      background-size: cover;
    }
    .right {
      width: 600px;
      height: 100%;
      background-image: url("../..//assets/register.png");
      background-size: 100% 100%;
      padding: 40px 65px;
      box-sizing: border-box;
      z-index: 999;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      .title {
        font-size: 26px;
        font-weight: 500;
        color: #13fffc;
      }
      .li {
        width: 100%;
        height: 45px;
        border-bottom: 1px solid rgba(19, 255, 252, 0.3);
        box-sizing: border-box;
        display: flex;
        align-items: center;
        input {
          flex: 1;
          background: #060c18;
          border: none;
          font-size: 16px;
          outline: none;
          color: #13fffc;
          padding: 0 10px 0 0;
          box-sizing: border-box;
        }
        span {
          display: block;
          width: 160px;
          font-size: 16px;
          color: #00fff9;
          text-align: right;
        }
      }
      .li2 {
        width: 100%;
        display: flex;
        align-items: flex-end;
        .avatar-uploader {
          width: 100px;
          height: 90px;
          border: 1px solid #1a4e54;
          box-sizing: border-box;
          display: flex;
          justify-content: center;
          align-items: center;
          .avatar-uploader-icon {
            width: 100%;
            height: 100%;
            font-size: 40px;
            color: #33eefc;
          }
        }
        .avatar {
          width: 100%;
          height: 90px;
          display: block;
        }
        span {
          color: #095c5f;
          margin-left: 16px;
          font-size: 16px;
        }
      }
      .li3 {
        width: 100%;
        height: 40px;
        display: flex;
        .li3_left {
          select {
            width: 70px;
            height: 40px;
            background: rgba(35, 254, 246, 0.1);
            border: 1px solid rgba(72, 236, 231, 0.3);
            color: #13fffc;
            outline: none;
            padding-left: 10px;
            box-sizing: border-box;
            font-size: 16px;
            option {
              background: #000;
              color: #00d9dd;
            }
          }
        }
        .li3_right {
          margin-left: 12px;
          width: 460px;
          height: 40px;
          background: rgba(35, 254, 246, 0.1);
          border: 1px solid rgba(72, 236, 231, 0.3);
          font-size: 14px;
          outline: none;
          color: #13fffc;
          padding: 0 10px;
          box-sizing: border-box;
        }
      }
      .xieyi {
        cursor: pointer;
        color: #0a7879;
        font-size: 16px;
        a {
          color: #13fffc;
          font-size: 16px;
        }
        span {
          color: #0a7879;
          font-size: 16px;
        }
      }
      .btn {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        span {
          display: block;
          width: 100%;
          height: 50px;
          background: linear-gradient(90deg, #1dafaa 0%, #23fef6 100%);
          font-size: 20px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #f6f6f6;
          line-height: 50px;
          text-align: center;
        }
      }
    }
  }
}
</style>
